export default __webpack_public_path__ + "static/media/BANNER-PAGINA-WEB-FORTALECIMIENTO-2026.62a89ae8.jpeg";